// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609210934/js/" + chunkId + "." + {"44":"0cac4c83","225":"5c32b0ed","481":"e6f1a9c4","486":"70bd2f0a","770":"7412faef"}[chunkId] + ".0.9555286263065774.chunk.js";
};